import { createContext } from 'react';
import { getStatus } from './utils';
export var FeatureFlagContext = createContext({
    client: null,
    factory: null,
    lastUpdate: null,
    flagUser: { username: '', name: '', email: '' },
    status: getStatus(null)
});
//# sourceMappingURL=FeatureFlagContext.js.map